
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1588860775701",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3764",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1011.2 320L928 179.2c-44.8-64-102.4-89.6-217.6-89.6h-83.2c-12.8 0-19.2 6.4-25.6 12.8l-19.2 44.8-70.4 83.2-64-76.8-19.2-38.4c0-12.8-12.8-19.2-25.6-19.2h-89.6c-102.4 0-172.8 32-224 102.4L12.8 320C0 345.6 6.4 377.6 25.6 390.4L128 480c19.2 12.8 38.4 19.2 57.6 12.8h6.4l6.4-6.4v371.2c0 76.8 57.6 134.4 134.4 134.4h345.6c76.8 0 134.4-57.6 134.4-134.4V480h32c12.8 0 32-6.4 44.8-12.8L992 384c25.6-6.4 32-38.4 19.2-64zM857.6 428.8h-12.8L825.6 416h-12.8c-6.4 0-12.8-6.4-19.2-6.4C780.8 416 768 428.8 768 448v409.6c0 44.8-38.4 76.8-76.8 76.8h-352c-44.8 0-76.8-38.4-76.8-76.8V448c-6.4 0-6.4 0-6.4-6.4 0-12.8-12.8-25.6-32-25.6-12.8 0-25.6 6.4-25.6 6.4l-32 19.2H160L57.6 352l76.8-121.6c32-44.8 76.8-76.8 172.8-76.8H384l12.8 25.6s0 6.4 6.4 6.4l76.8 89.6c19.2 19.2 51.2 19.2 64 0l76.8-89.6s0-6.4 6.4-6.4l12.8-25.6h70.4c108.8 0 140.8 19.2 166.4 64L960 352l-102.4 76.8z",
        "fill": "#ffffff",
        "p-id": "3765"
      }
    }
  ]
})
    }
  